// Where a viewport's `progress` goes. Since #565 each event names its stream (`of`): the pack's load
// fills the loading bar, a section's first read of the pack's volumes (`load` no longer reads them)
// shows in the HUD, and a sim slot's read changes nothing on screen. An event without `of`, from an
// older build, is the pack's, as before.

import type { AtlasState } from '../app/store.ts';
import type { ViewportEvent } from './api.ts';

type Progress = Extract<ViewportEvent, { ev: 'progress' }>;

/** The store's change for one progress event, or null for none. */
export function progressUpdate(s: Pick<AtlasState, 'load'>, e: Progress): Partial<Pick<AtlasState, 'load' | 'reading'>> | null {
  switch (e.of) {
    case undefined:
    case 'pack':
      // A new pack's load starts any section read over.
      return { load: { ...s.load, loaded: e.loaded, total: e.total }, reading: null };
    case 'volumes':
      return { reading: e.total > 0 && e.loaded < e.total ? { loaded: e.loaded, total: e.total } : null };
    default:
      return null;
  }
}
